import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

type AvatarOptionsPanelContainerAttributes = {
  isFocus?: boolean;
  buttons: boolean;
};

export default styled.div(
  ({ buttons, isFocus = true }: AvatarOptionsPanelContainerAttributes) => css`
    box-shadow: 0px -4px 4px 0px rgb(222 13 13 / 0.25);
    transform: translateY(${isFocus ? '-300px' : 0});
    background-color: ${Theme.color.white};

    padding: 16px 0px 40px;
    border-radius: 16px;

    position: relative;
    transition: 0.5s;
    margin: 0 auto;

    width: 100%;
    z-index: 1;

    right: 0;
    left: 0;

    ${!buttons &&
    css`
      padding-bottom: 24px;
    `}
  `
);
